var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjTempoB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6754)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29C22.5081 29 29 22.5081 29 14.5C29 6.49187 22.5081 0 14.5 0C6.49187 0 0 6.49187 0 14.5C0 22.5081 6.49187 29 14.5 29Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2641_6754",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.452 6.54883H6.54883V22.452H22.452V6.54883Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2641_6754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5013 7.87402C18.1611 7.87402 21.1277 10.8406 21.1277 14.5004C21.1277 18.1601 18.1611 21.1267 14.5013 21.1267C10.8416 21.1267 7.875 18.1601 7.875 14.5004C7.875 10.8406 10.8416 7.87402 14.5013 7.87402ZM14.5013 10.5246C14.3256 10.5246 14.1571 10.5944 14.0328 10.7186C13.9085 10.8429 13.8387 11.0115 13.8387 11.1872V14.5004C13.8387 14.6761 13.9086 14.8446 14.0329 14.9688L16.0208 16.9568C16.1457 17.0775 16.3131 17.1442 16.4869 17.1427C16.6606 17.1412 16.8268 17.0715 16.9497 16.9487C17.0725 16.8258 17.1422 16.6596 17.1437 16.4859C17.1452 16.3121 17.0784 16.1448 16.9577 16.0198L15.164 14.226V11.1872C15.164 11.0115 15.0942 10.8429 14.9699 10.7186C14.8456 10.5944 14.6771 10.5246 14.5013 10.5246Z",
    fill: "#6796CF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjTempoB);
export default __webpack_public_path__ + "static/media/IconProjTempoB.0268e62c6197c244058efd38629b42b1.svg";
export { ForwardRef as ReactComponent };